<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.full_name" v-bind="fieldsDefinitions.full_name"
        @error="(err) => setFieldError('full_name', err)"/>
      <ccs-input class="ccs-8" v-model.trim="fieldsValues.short_name" v-bind="fieldsDefinitions.short_name"
        @error="(err) => setFieldError('short_name', err)"/>
      <ccs-input class="ccs-4" v-model="fieldsValues.event_type_id" v-bind="fieldsDefinitions.event_type_id"
        :items="eventTypesForSelect" @change="onEventTypeSearch"
        @error="(err) => setFieldError('event_type_id', err)"/>
      <ccs-input class="ccs-4" v-model="fieldsValues.started_at" v-bind="fieldsDefinitions.started_at"
        @error="(err) => setFieldError('started_at', err)"/>
      <ccs-input class="ccs-4" v-model="fieldsValues.ended_at" v-bind="fieldsDefinitions.ended_at"
        @error="(err) => setFieldError('ended_at', err)"/>
      <ccs-input class="ccs-4" v-model="fieldsValues.day_c_1" v-bind="fieldsDefinitions.day_c_1"
        @error="(err) => setFieldError('day_c_1', err)"/>
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.location" v-bind="fieldsDefinitions.location"
        @error="(err) => setFieldError('location', err)"/>
    </div>
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.description" v-bind="fieldsDefinitions.description"
        @error="(err) => setFieldError('description', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'CreateEvent',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        full_name: {
          isValid: false,
          error: '',
          required: true,
          type: "textarea",
          label: "Полное наименование",
          placeholder: "Введите наименование",
        },
        short_name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Сокращённое наименование",
          placeholder: "Введите наименование",
        },
        event_type_id: {
          isValid: false,
          error: '',
          required: true,
          type: "autocomplete",
          label: "Тип мероприятия",
          placeholder: "Поиск по названию",
        },
        started_at: {
          isValid: false,
          error: '',
          required: true,
          type: "date",
          label: "Дата начала (C1)",
        },
        ended_at: {
          isValid: false,
          error: '',
          required: true,
          type: "date",
          label: "Дата завершения (C+1)",
        },
        day_c_1: {
          isValid: false,
          error: '',
          required: true,
          type: "date",
          label: "День C-1",
        },
        location: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Место проведения",
          placeholder: "Введите место проведения",
        },
        description: {
          isValid: false,
          error: '',
          required: false,
          type: "textarea",
          label: "О мероприятии",
          placeholder: "Введите описание мероприятия",
        },
      },
      eventTypesForSelect: [],
      fieldsValues: {
        event_type_id: undefined,
        full_name: '',
        short_name: '',
        started_at: new Date(),
        ended_at: new Date(),
        day_c_1: new Date(),
        location: '',
        description: '',
      },
    };
  },
  computed: {
    ...mapState('events', ['eventTypes']),
  },
  methods: {
    ...mapActions('events', ['createEvent']),
    async onEventTypeSearch(text) {
      [this.eventTypesForSelect] = await this.getAutocompleteData('/v1/events/types/list', text, 'id', 'name');
    },
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        try {
          await this.createEvent(this.fieldsValues);
          this.$toasted.success('Мероприятие создано!');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    }
  }
}
</script>

<style>

</style>